function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { parseSearchFiltersToUrl } from '~/apps/pu-links/domain/SearchUrl';
import { getLangFallbackUrl } from '~/lang/utils/langfetch';
import { getTransformObject } from '~/shared/photos/transforms';
import { getWKTPointFromGeoPoint } from '~/utility/geo/GeoLocation';
import { getPointFromStringOrDefault } from '~/utility/geo/latLng';
import { keysToCamel } from '~/utility/toCamel';
import { campsiteMapPointSchema, campsiteMapPopupSchema } from '../schemas';
import { formatBounds } from './bounds';
export class FetchCampsiteMapSearchService {
  search(filters, langCode, logger, fetchOptions) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var params = _this.filtersToParams(filters);
      var fieldsToShow = ['cheapest_lead_price', 'id', 'lead_price', 'point', 'slug'];
      var gtmLogRequest = useGtmLogRequest('FetchCampsiteMapSearchService-search', logger);
      gtmLogRequest.markStart();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var url = getLangFallbackUrl(langCode, "/search2/postgres-nonprice/?fields=".concat(fieldsToShow.join(','), "&bookable=2&sort=none&facet_counts=none&seo=0&").concat(params.toString()));
      var response = yield $fetch(url, fetchOptions);
      gtmLogRequest.markEnd();
      if (!response) {
        // return nothing early if response is empty, otherwise it will throw an error later on
        return;
      }
      return {
        campsites: _this.formatResults(keysToCamel(response.results)),
        pagination: {
          currentPage: Number(response.page),
          totalPages: response.num_pages,
          totalCount: response.count
        },
        bounds: response.bounding_box ? formatBounds(response.bounding_box) : null,
        title: response.title,
        heading: response.heading,
        bookable: !!response.bookable,
        category: response.category,
        count: response.bookable_count,
        path: response.path,
        point: response.point,
        leadPrice: response.lead_price,
        cheapestLeadPrice: response.cheapest_lead_price,
        sortOptions: response.sort_options,
        sortOption: response.sort || response.sort_field,
        maxPrice: response.max_price
      };
    })();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formatResults(results) {
    return results.map(campsite => {
      var point = getWKTPointFromGeoPoint(getPointFromStringOrDefault(campsite.point));
      var {
        lat,
        lng
      } = getPointFromStringOrDefault(point);
      return campsiteMapPointSchema.parse(_objectSpread(_objectSpread({}, campsite), {}, {
        id: campsite.id.toString(),
        price: campsite.cheapestLeadPrice ? campsite.cheapestLeadPrice[0] : undefined,
        point,
        lat,
        lng
      }));
    });
  }

  // tslint:disable-next-line cognitive-complexity
  filtersToParams(filters) {
    var params = new URLSearchParams([]);
    for (var param of parseSearchFiltersToUrl(_objectSpread({}, filters))) {
      params.append(param.filterName, param.filterValue);
    }
    if (params.get('bounds')) {
      // remove bounds if path
      if (params.get('path')) {
        params.delete('bounds');
      } else {
        // only full bookable if bounds and no path
        // params.append('bookable', '1')
      }
    }
    return params;
  }
  fetchCampsiteBySlug(slug, langCode, logger) {
    return _asyncToGenerator(function* () {
      var _campsite$primaryPhot;
      var gtmLogRequest = useGtmLogRequest('FetchCampsiteMapSearchService-fetchCampsiteBySlug', logger);
      gtmLogRequest.markStart();
      var campsite = yield $fetch(getLangFallbackUrl(langCode, "/_/campsite-details/slim/".concat(slug, "/")));
      gtmLogRequest.markEnd();
      return campsiteMapPopupSchema.parse(_objectSpread(_objectSpread({}, campsite), {}, {
        bookable: campsite.isBookable,
        hierarchy: campsite.hierarchyTextShort,
        photo: campsite.primaryPhoto ? {
          url: getTransformObject('map', campsite.primaryPhoto.url.master_image),
          caption: ((_campsite$primaryPhot = campsite.primaryPhoto) === null || _campsite$primaryPhot === void 0 ? void 0 : _campsite$primaryPhot.caption) || ''
        } : null,
        price: campsite.leadPrice ? campsite.leadPrice : undefined,
        status: campsite.isBookable ? 'bookable' : 'free'
      }));
    })();
  }
}
export function getCampsiteBySlug(slug, langCode, logger) {
  var service = new FetchCampsiteMapSearchService();
  return service.fetchCampsiteBySlug(slug, langCode, logger);
}